import React from "react";
import Dropdown from "./components/Dropdown";
import ExampleDropdown from "./components/DropdownHeadless";
import Navbar from "./components/Navbar";
import ResultBox from "./components/ResultBox";
import {Searchbar} from "./components/Searchbar";
import { useState } from "react";
import SidebarChat from "./components/sidebarChat";
import { tipos_contratos, modalidades_contratacion } from "./components/sidebarChat";
import Pagination from "./components/paginate";


function App() {
  const [query, setQuery] = useState('');
  const [filteredResults, setFilteredResults] = useState('');
  const [lastClic, setLastClic] = useState(null);
  const [searchVal, setSearchVal] = useState('');
  const [pageNumber, setPageNumber] = useState(1);
  // const [resultsNumber, setResultsNumber] = useState(10);
  

  // El siguiente objeto debe cuadrar con: como esta en Typsense, como esta en el sidebarChat y como esta en el Searchbar
  const [selected, setSelected] = useState({
    "tipo_busqueda": "Descripción del contrato",
    // "tipo_de_contrato": [tipos_contratos[0].label, tipos_contratos[1].label],
    "tipo_de_contrato": ["Todos"],
    "modalidad_de_contratacion": [modalidades_contratacion[3].label, modalidades_contratacion[11].label]
  });

  return (
    
    <div>
      
      <div className="flex">
        <div className="hidden md:block w-96">
          <div className="h-16 border-b-2 border-gray-400 flex items-center justify-center">
          {/* <div className="w-1/4 bg-gray-800"> */}

          {/* Sidebar receives query results (query) to filter them with the filters */}
          <SidebarChat onSelected={setSelected} onQuery={setQuery} searchValue={searchVal}/>
          </div>
        </div>

        <main class="min-w-0 flex-1 overflow-auto p-4">
        <Navbar></Navbar>
            {/* In the following line, we set 'query' variable with the data that is exported from Searchbar component. */}
            <Searchbar selected_dict={selected} onQuery={setQuery} onSearch={setSearchVal}></Searchbar> 
            {/* <Example query={query}></Example> */}
            <ResultBox query = {query}> </ResultBox>
            {/* <MultiSelect></MultiSelect> */}
            <Pagination resultsNumber = {query.found} setPageNumber = {setPageNumber} searchValue = {searchVal} filtersDict={selected} onQuery={setQuery} ></Pagination>

 
        </main>

      </div>
      


    </div>

  );
}

export default App;